export default {
  placeDetails: {
    'layer': 'Layer',
    'lat': 'Lat.',
    'lon': 'Lon.',
    'notAvailable': 'Non avviabile',
    'placeDetails': 'Dettagli del luogo',
    'placeName': 'Nome',
    'latlngCopied': 'Latitudine e longitudine copiate',
    'lnglatCopied': 'Longitudine e latitudine copiate',
    'copyLatlng': 'Copia in formato latitudine,longitudine',
    'copyLnglat': 'Copia in formato longitudine,latitudine',
    'satelliteView': 'Visione da satellite'
  }
}
